<template>
  <div class="sold">
      <div class="sold__bg" :style="{backgroundImage: `url(${photo})`}"></div>
      <div class="sold__container">
        <div class="sold__address">{{fullAddress}}</div>
        <div class="sold__label">Sold</div>
      </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import beforeRouteEnter from '@/mixins/beforeRouteEnter'

  export default {
    mixins: [
			beforeRouteEnter
		],
    computed: {
      ...mapState('tours', ['ready', 'fullAddress']),
      ...mapGetters('tours', ['getPhotoByIndex']),
      photo () {
        return this.ready && this.getPhotoByIndex(0).urls[1].url
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/styles/mixins";

  .sold {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    padding: 1.25rem;
    overflow: hidden;

    &__bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      filter: grayscale(1);
    }

    &__container {
      position: relative;
      margin: auto;
      transform: rotate(-15deg);
    }

    &__address {
      margin-bottom: 0.9375rem;
      font-size: 1.25rem;
      color: var(--color-sold-address);
      text-align: center;
      text-shadow: 2px 2px 5px rgba(0,0,0,.7);
    }

    &__label {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.75rem 3.125rem;
      background-color: var(--color-sold-label);
      font-size: 3rem;
      font-weight: 700;
      color: var(--color-sold-label-text);
      text-transform: uppercase;
      letter-spacing: 0.125rem;

      @include tablet() {
        font-size: 5rem;
        padding: 0.75rem 6.25rem;
      }
    }
  }
</style>
